<template>
  <!-- 9Aコード管理保守新規画面 -->
  <div>
    <!-- ●●●上部メニュー●●● -->
    <Header :type="menu_type" :title="title" />
    <div class="container-fluid px-4 py-4 min-vh-85">
      <div class="row d-flex justify-content-center mt-2 mb-2">
        <div class="col-md-12">
          <div class="media">
            <div class="media-body pb-3">
              <div class="d-flex justify-content-between">
                <h5 class="text-secondary m-0"><span class="oi oi-brush"></span><strong> 9Aコード管理保守新規</strong></h5>
                <router-link to="/products9A-classes-maintenance" class="btn btn-cancel m-0">
                  <span class="oi oi-circle-x"></span> キャンセル
                </router-link>
              </div>
            </div>
          </div>
          <div class="main-card mb-3 card">
            <div v-if="getMessageFlg" class="card-header">
              <div class="alert alert-danger" role="alert" v-if="errorMessages.length">
                <ul v-for="(message, index) in errorMessages" :key="index" style="list-style: none;">
                  <li>{{ message }}</li>
                </ul>
              </div>
            </div>
            <div class="card-body">
              <p>編集途中の情報は保持されません。編集が終わりましたら、必ず[保存]ボタンを押してください。</p>
              <hr>
              <validation-observer ref="observer">
                <div class="row mt-2">
                  <!-- 製品分類コード -->
                  <div class="col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-4 form-group">
                    <validation-provider :rules="{required:true,numeric:true,min_value:9000,max_value:9999}" v-slot="{ classes, errors }">
                      <div :class="classes">
                        <label for="product_class_id" class="form-label">製品分類コード</label>
                        <input type="text" id="product_class_id" class="form-control" v-model.lazy="obj.product_class_id"  @change="checkProductClassId($event)" maxlength="4">
                        <small class="form-text text-muted">必須項目です。</small>
                        <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="row">
                  <!-- 製品分類名 -->
                  <div class="col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-4 form-group">
                    <validation-provider rules="required|max:30" v-slot="{ classes, errors }">
                      <div :class="classes">
                        <label for="product_class_name" class="form-label">製品分類名</label>
                        <input type="text" id="product_class_name" class="form-control" v-model="obj.product_class_name" maxlength="30">
                        <small class="form-text text-muted">必須項目です。</small>
                        <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="row">
                  <!-- シーケンス -->
                  <div class="col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-4 form-group">
                    <validation-provider :rules="{required:true,numeric:true,max:4,max_value:obj.max}" v-slot="{ classes, errors }">
                      <div :class="classes">
                        <label for="sequence" class="form-label">現在No.</label>
                        <input type="text" id="sequence" class="form-control" v-model="obj.sequence" maxlength="4">
                        <small class="form-text text-muted">必須項目です。</small>
                        <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                </div>
                <div class="row">
                  <!-- 最小～最大 -->
                  <div class="col-sm-12 col-md-10 col-lg-8 col-xl-6 col-xxl-4 form-group">
                    <validation-provider :rules="{required:true,numeric:true,max:4,max_value:obj.max}" v-slot="{ classes, errors }">
                      <div :class="classes">
                        <label for="min" class="form-label">最小No.～最大No.</label>
                        <b-input-group>
                          <input type="text" id="min" class="form-control" v-model="obj.min" maxlength="4">
                          <b-input-group-text>～</b-input-group-text>
                          <input type="text" id="max" class="form-control" v-model="obj.max" maxlength="4">
                        </b-input-group>
                        <small class="form-text text-muted">必須項目です。</small>
                        <span id="error" v-if="errors[0]">{{ errors[0] }}</span>
                      </div>
                    </validation-provider>
                  </div>
                </div>
              </validation-observer>
            </div>
             <!-- 保存ボタン -->
            <div class="card-footer">
              <div class="row justify-content-md-center pb-4">
                <div class="col-lg-2">
                  <button type="button" class="btn btn-primary btn-block" @click="save"><span class="oi oi-circle-check"></span> 保存</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- ●●●フッター●●● -->
    <Footer />
    <!-- ●●●確認モーダル●●● -->
    <CONFIRM @from-child="closeConfirmModal" :confirmMessage="confirmMessage" />
  </div>
</template>
<script>
import Header from '@/components/navigation/header.vue';
import Footer from '@/components/navigation/footer.vue';
import CONFIRM from '@/components/modal/confirm.vue';
import { API, graphqlOperation } from 'aws-amplify';
import { executeTransactSql } from '@/graphql/mutations';
import { addOperationLogs, init, CreateColRow, CreateInsertSql, escapeQuote, getUserCol, isSystemEditable, selectOneTable } from '@/assets/js/common.js';

import { DISP_MESSAGES } from '@/assets/js/messages';

// ログ出力用モジュール名
const MODULE_NAME = 'products9A-classes-input';

export default {
  name: 'PRODUCTS9A-CLASSES-INPUT',
  /** コンポーネント */
  components: {
    Header,
    Footer,
    CONFIRM,
  },
  /** データ */
  data() {
    return {
      // ヘッダ
      menu_type: 'user',
      title: '9Aコード管理保守新規',
      // ユーザ名
      username: this.$store.getters.user.username,
      // 9Aコード対象
      obj: {},
      // 処理結果エラーメッセージ
      errorMessages: [],
      // 確認ダイアログ用
      confirmMessage: [],
    }
  },
  computed: {
    /* メッセージがあるかどうかの返却 */
    getMessageFlg: function() {
      return this.errorMessages.length > 0
    },
  },
  /**
   * mountedライフサイクルフック
   */
  async mounted() {
    await this.fetchData()
    init(); // common.jsにて初期化処理
    scrollTo(0,0);
    this.$store.commit('setLoading', false);
  },
  methods:{
    /**
     * 画面に表示するデータを取得します。
     */
    async fetchData() {
      this.busy = true;
      // データセット 
      this.obj = {
        product_class_id: '',
        product_class_name: '',
        max: 9999,
        min: 1,
        sequence: 1,
      }
      this.busy = false;
    },
    /**
     * 保存ボタンの押下
     */
    async save() {
      this.$store.commit('setLoading', true);
      this.errorMessages = [];
      if (await this.$refs.observer.validate()) {
        await this.saveConfirm();
      } else {
        document.querySelector('#error:first-of-type').scrollIntoView({
          block: 'center',
          inline: 'nearest'
        });        
      }

      this.$store.commit('setLoading', false);
    },
    /* 保存時の確認ダイアログ表示 */
    async saveConfirm() {
      console.log('保存');
      this.confirmMessage = [];
      this.confirmMessage.push('入力された情報で保存します。');
      this.confirmMessage.push('よろしいですか？');
      this.$bvModal.show('confirmModal');
    },
    /* 確認モーダルを閉じた時 */
    async closeConfirmModal(okFlg) {
      const functionName = 'closeConfirmModal';
      console.log(okFlg);
      try {
        // モーダルから渡された値の有無チェック
        if (typeof okFlg != 'undefined') {
          console.log('保存処理開始');
          this.$store.commit('setLoading', true);
          await this.execInsert();
          if (this.errorMessages.length === 0) {
            this.$router.push({ 
              name: 'PRODUCTS9A-CLASSES-INQUIRY', 
              query: { product_class_id: this.obj.product_class_id },
              params: { successMessages: [DISP_MESSAGES.SUCCESS['1001']] }  
            });
          }
          this.$store.commit('setLoading', false);
          console.log('保存処理終了');
        }
      } catch(error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {}, error);
        console.log(error);
        this.errorMessages.push(DISP_MESSAGES.DANGER['3005']);
      }
      // メッセージが１件でもある場合は一番上へスクロール
      if (this.errorMessages.length != 0) {
        scrollTo(0,0);
      }
      this.$store.commit('setLoading', false);
    },
    /**
     * 登録処理
     */
    async execInsert() {
      // 9Aコード重複確認
      if (await this.checkDuplicateKey()) {
        // 9Aコード管理マスタ登録
        await this.execInsertProducts9AClasses()
      }
    },
    /**
     * 9Aコード管理マスタ登録
     */
    async execInsertProducts9AClasses(){
      const functionName = 'execInsertProducts9AClasses';

      const colList = [];
      // 製品分類名
      colList.push(CreateColRow('product_class_id', Number(this.obj.product_class_id), 'INT'));
      // 製品分類名
      colList.push(CreateColRow('product_class_name', await escapeQuote(this.obj.product_class_name), 'VARCHAR'));
      // 最大
      colList.push(CreateColRow('max', Number(this.obj.max), 'INT'));
      // 最小
      colList.push(CreateColRow('min', Number(this.obj.min), 'INT'));
      // シーケンス
      colList.push(CreateColRow('sequence', Number(this.obj.sequence), 'INT'));
      // 新規と更新ユーザー
      const colBothUser = await getUserCol(this.username, 'both')

      const sql = CreateInsertSql(colList.concat(colBothUser), 'full', 'm_9a_products_classes');
      const SQLs = [sql];

      // 月次更新・取引先コード切替・製品コード切替などが実行中かどうかを確認します。
      try {
        const msg = await isSystemEditable();
        if (msg !== null) {
          this.errorMessages.push(msg);
          return;
        }
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, '予期しないエラーが発生しました。', error);
        this.errorMessages.push(DISP_MESSAGES.DANGER['3001']);
        return;
      }

      let result = null;
      try {
        result = await API.graphql(graphqlOperation(executeTransactSql, { SQLs }));
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs,
        }, error);
        this.errorMessages.push(DISP_MESSAGES.DANGER['3001']);
        return;
      }
      if (result.errors) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'executeTransactSql',
          SQLs: SQLs,
          result: result
        });
        this.errorMessages.push(DISP_MESSAGES.DANGER['3001']);
        return;
      }
      const body = JSON.parse(result.data.executeTransactSql.body);
      let logLevel = 'Info';
      if (body.error) {
        logLevel = 'Error';
        this.errorMessages.push(DISP_MESSAGES.DANGER['3001']);
      }
      await addOperationLogs(logLevel, MODULE_NAME, functionName, {
        graphqlOperation: 'executeTransactSql',
        SQLs: SQLs,
        'result.data.executeTransactSql': {
          statusCode: result.data.executeTransactSql.statusCode,
          body: body
        }
      });
    },
    /**
     *  9Aコード重複確認
     */
    async checkProductClassId(e) {
      const product_class_id = Number(e.target.value)
      if (product_class_id && product_class_id >= 9000) {
        this.errorMessages = []
        this.checkDuplicateKey()
      }
    },
    /**
     *  9Aコード重複確認
     * @returns {boolean} 製品分類コード存在するか
     */
    async checkDuplicateKey() {
      const functionName = 'checkDuplicateKey';
      const product_class_id = Number(this.obj.product_class_id)
      let result = null;
      let where_clause = `AND product_class_id = ${product_class_id}`
      
      try {
        result = await selectOneTable('m_9a_products_classes', where_clause);
      } catch (error) {
        await addOperationLogs('Error', MODULE_NAME, functionName, {
          graphqlOperation: 'list_m_9a_products_classes',
          where_clause: where_clause
        }, error);
        return;
      }
      if(result == null || result.length == 0) {
        return true  
      } else {
        this.errorMessages.push(DISP_MESSAGES.WARNING['2004']);
        return
      }
    },
  }
}
</script>
